<template>
 <div :class="windowClass">
    <v-row  no-gutters>
           <v-col cols="12"  class="pa-1 text-center sm-font">
                LAST UPDATE: 
          </v-col>
        <v-col cols="6" class="pa-1">
           <va-stat-card 
              color="secondary"
              icon="mdi-cash-register"
              label="Sales"
              :data="'100'"
              sup=""
            />
        </v-col>
        <v-col cols="6"  class="pa-1">
            <va-stat-card 
              color="secondary"
              icon="mdi-file-edit"
              label="BOOKING"
              :data="'1'"
              sup=""
            />
        </v-col>
          
        <v-col cols="6" class="pa-1">
           <va-stat-card 
              color="secondary"
              icon="mdi-account"
              label="CUSTOMERS"
              :data="'210'"
              sup=""
            />
        </v-col>
        <v-col cols="6"  class="pa-1">
            <va-stat-card 
              color="secondary"
              icon="mdi-bottle-soda-classic-outline"
              label="VARIANTS"
              :data="'2'"
              sup=""
            />
        </v-col>
        <v-col cols="6"  class="pa-1">
            <v-btn color="primary"  block><v-icon left>mdi-receipt</v-icon> New Invoice</v-btn>
        </v-col>
          <v-col cols="6"  class="pa-1">
            <v-btn color="info"  block><v-icon left>mdi-text-box-plus</v-icon> New Booking</v-btn>
        </v-col>
        <v-col cols="12"  class="pa-1">
              <v-btn color="primary" small text> R1: 12</v-btn>
        </v-col>
    </v-row>
  </div>
</template>
<script>
import { API_MIXINS } from '@/mixins/api_mixins.js'
import {
  mapMutations
} from 'vuex'
  export default {
    mixins: [API_MIXINS],
    data: () => ({
     
    }),
    beforeCreate: function () {
      if (!this.$session.exists()) {
        this.$router.push('/')
      }
    },
    created() {
       if (this.$session.exists()) {
          this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + this.$session.get('jwt')
          this.setLoggedIn(true) 
          this.PING()
        }
    },
    computed:{
       windowClass() {
        if(this.$store.state.responsive){
          return "va-reponsive"
        } else {
          return "va-not-reponsive"
        }
      },
    },
    methods: {
      ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText', 'setLoggedIn']),
      
    },
  }
</script>